import React from 'react';
import {
  CustomTrainingSection,
  CustomTrainingContent,
  InlineLinks,
  TextLink,
  CustomTrainingPoints,
  CustomPoint,
} from './CustomTraining.styles';
const CustomTraining = () => {
  return (
    <CustomTrainingSection>
      <CustomTrainingContent>
        <p className="eyebrowHeader">Need Something Specific?</p>

        <h2>Training Built Around Your Workplace</h2>

        <p>
          Not every organization has the same training requirements. If your
          company needs training tailored to its workplace, procedures, or
          specific operations, talk to our team about custom course development.
        </p>

        <InlineLinks>
          <TextLink to="/contact-us">
            Ask About Custom Training
            <span aria-hidden="true">→</span>
          </TextLink>

          <TextLink to="/training">
            Browse Current Courses
            <span aria-hidden="true">→</span>
          </TextLink>
        </InlineLinks>
      </CustomTrainingContent>

      <CustomTrainingPoints>
        <CustomPoint>
          <span>01</span>
          <p>Company-specific training needs</p>
        </CustomPoint>

        <CustomPoint>
          <span>02</span>
          <p>Workplace procedures and operations</p>
        </CustomPoint>

        <CustomPoint>
          <span>03</span>
          <p>Training designed for your team</p>
        </CustomPoint>
      </CustomTrainingPoints>
    </CustomTrainingSection>
  );
};

export default CustomTraining;
